module.exports = __webpack_public_path__ + "img/tjszgyy01.f91e6350.jpg";